import { History, TrendingUp } from 'lucide-react';
import { useState } from 'react';
import { PageHeader } from '@/components/PageHeader';
import { Card, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useCurrentLocal, useHasRole } from '@/lib/local-context';
import { BulkWizard } from './BulkWizard';
import { HistoryTab } from './HistoryTab';

export function PreciosPage() {
  const local = useCurrentLocal();
  const canEdit = useHasRole('OWNER', 'MANAGER');
  const [tab, setTab] = useState('update');

  return (
    <div className="mx-auto w-full max-w-4xl">
      <PageHeader title="Precios" description="Actualizá muchos precios de una sola vez y revisá el historial de cambios." />
      {!canEdit ? (
        <Card>
          <CardContent className="text-sm text-muted-foreground">
            Solo el dueño o el encargado del local pueden actualizar precios.
          </CardContent>
        </Card>
      ) : (
        <Tabs value={tab} onValueChange={setTab} className="gap-4">
          <TabsList className="w-full sm:w-fit">
            <TabsTrigger value="update">
              <TrendingUp /> Actualizar precios
            </TabsTrigger>
            <TabsTrigger value="history">
              <History /> Historial
            </TabsTrigger>
          </TabsList>
          <TabsContent value="update" forceMount hidden={tab !== 'update'}>
            <BulkWizard localId={local.id} />
          </TabsContent>
          <TabsContent value="history">
            <HistoryTab localId={local.id} onStartUpdate={() => setTab('update')} />
          </TabsContent>
        </Tabs>
      )}
    </div>
  );
}
